// extracted by mini-css-extract-plugin
export var content = "_ac-3";
export var list = "_ac-4";
export var settingsContent = "_ac-7";
export var settingsPanel = "_ac-8";
export var state = "_ac-6";
export var triggerBadge = "_ac-2";
export var triggerButton = "_ac-1";
export var triggerShell = "_ac-0";
export var unreadDot = "_ac-5";